import { Typography } from '@global-engineering-shared/gweb-material-ui';

import Dialog from 'components/Dialog';
import { useDialog } from 'context/DialogProvider/DialogProvider';
import { EntityActions } from 'utils/actions';
import { ENTITIES_PAGE_ACTION_DIALOG_ID } from 'utils/defaults';
import { LiveStatus } from 'utils/statuses';

export interface IEntitiesPageActionDialogProps {
  action: EntityActions;
  status: LiveStatus;
}

const EntitiesPageActionDialog = ({ action, status }: IEntitiesPageActionDialogProps) => {
  const { isDialogOpen, closeDialog } = useDialog();
  const dialogId = ENTITIES_PAGE_ACTION_DIALOG_ID + action;

  return (
    <Dialog
      isOpen={isDialogOpen(dialogId)}
      handleClose={() => closeDialog(dialogId)}
      handleContinue={() => closeDialog(dialogId)}
      name="EntitiesPageActionDialog"
      title="Action Selected Entities"
      content={
        <Typography color="textPrimary" variant="body2">
          Cannot <strong>{action.toLowerCase()}</strong> selected entities, they must all have the
          following state: <strong>{status}</strong>
        </Typography>
      }
    />
  );
};

export default EntitiesPageActionDialog;
